import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialNumberComponent } from './social-number/social-number.component';
import { DownloadAppBannerModule } from '../download-app-banner/download-app-banner.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [SocialNumberComponent],
  exports: [SocialNumberComponent],
  imports: [
    CommonModule,
    DownloadAppBannerModule,
    SharedModule
  ]
})
export class SocialNumberModule { }
